// extracted by mini-css-extract-plugin
export default {"DropdownButton":"DropdownButton_DropdownButton__R6tVJ","button":"DropdownButton_button__C3Fht","primary":"DropdownButton_primary__3blJ3","second":"DropdownButton_second__2pNR1"};